<template>
  <div class="index" :style="{'paddingTop': statusBar + 'rem'}">
    <Headerd :title="topicName" :back="true" left="首页" :white="true" />
    <div class="indexmain">
      <div class="banner">
        <img :src="topicId != 'undefined' ? require(`../../views/image/topic`+topicId+`.png`):''" alt />
      </div>
      <div class="moreApp">
        <div class="moreIcon backColor" :style="{'background-color':item.appUrl===0?'#f3f3f3':'#fff'}" v-for="(item, i) in menuList" :key="i" @click="gotoSmall(item.appUrl)">
          <div class="icon">
            <img class="appIconImg" v-if="item.appIcon" :src="item.appIcon" alt />
            <img v-if="item.isNew === '1'" class="newImg" src="@/views/image/newnew.png" alt />
            <img v-if="item.isHot === '1'" class="newImg" src="@/views/image/newhot.png" alt />
          </div>
          <p v-html="item.appName"></p>
        </div>

      </div>

      <div v-if="topicId==='1'" class="tips">
        <div class="tips_out">
          <p class="tips_one">状态订阅业务简介</p>
          <p class="tips_tow">扫码订阅：</p>
          <p class="tips_last">您可在报关单申报后，扫描申报成功提示界面中的二维码（或报关单查询界面中的二维码），订阅该票报关单的后续状态信息。可在APP“消息”中查看系统实时推送的最新状态信息。您也可将二维码发送其他需要的用户进行扫码订阅。</p>
          <p class="tips_tow">订阅记录：</p>
          <p class="tips_last">您可查询所有已订阅的单证记录，并可快捷查询到该单证的状态信息。</p>
          <p class="tips_tow">批量订阅：</p>
          <p class="tips_last">您可以按照个人/企业维度，批量订阅本人申报或本企业申报的多种类别业务单证状态信息。</p>
        </div>
      </div>
      <div v-if="topicId==='3'" class="tips">
        <div class="tips_out">
          <p class="tips_one">个人通关业务简介</p>
          <p class="tips_tow">跨境电商个人消费额度：</p>
          <p class="tips_last">可查询您的跨境电商个人年度消费额度，以及通关数据详情与税款数据详情。</p>
          <p class="tips_tow">快件个人物品：</p>
          <p class="tips_last">可查询您的快件个人物品通关状态。</p>
          <p class="tips_tow">邮包状态：</p>
          <p class="tips_last">可查询您的进出境邮递物品通关状态。</p>
          <p class="tips_tow">汽车证明书：</p>
          <p class="tips_last">可查询进口汽车证明书的公安部回执状态。</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import "@/views/css/index.scss";
import Headerd from "@/components/Headerd";
import { Grid, GridItem, Field } from "vant";
export default {
  name: "topicDetail",
  /**
   * 初始化数据
   */
  data() {
    return {
      // notice: [
      //   "海关总署署长倪岳峰主持召开促进跨境贸易便利化专项行动部署会",
      //   "李克强签署国务院令 公布《优化营商环境条例》"
      // ],
      statusBar: 0,
      menuList: [],
      topicId: `${this.$route.query.topicId}`,
      topicName: `${this.$route.query.topicName}`,
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
    console.log(this.statusBar);
    if (this.topicId == "undefined" || this.topicId == undefined) {
      this.topicId = localStorage.getItem("topicDetail_topicId");
      this.topicName = localStorage.getItem("topicDetail_topicName");
    }
    if (this.topicId && this.topicId != "undefined") {
      this.getTopicListAndApps();
    }
  },
  /**
   * 方法
   */
  methods: {
    BrmyAppFunction() {
      for (let i in this.menuList) {
        console.log(this.menuList[i].appName);
        this.menuList[i].appName = this.menuList[i].appName.replace(
          /\|\|/g,
          "<br/>"
        );
      }
    },
    getTopicListAndApps() {
      this.$http1
        .post("/zsdyckserver/app/getTopicListAndApps?topicId=" + this.topicId)
        .then((res) => {
          if (res.resultFlag === "1") {
            this.menuList = this.dataRecom(res.topicAppList);
            this.BrmyAppFunction();
            localStorage.setItem("topicDetail_topicId", this.topicId);
            localStorage.setItem("topicDetail_topicName", this.topicName);
          }
        });
    },

    dataRecom(values) {
      if (values.length % 3 === 0) {
        return values;
      } else {
        let obj = {
          appId: "",
          appName: "",
          appUrl: 0,
          nullType: "1",
        };
        let len = 3 - (values.length % 3);
        for (let index = 0; index < len; index++) {
          values.push(obj);
        }
        return values;
      }
    },

    /**
     * 跳转小应用
     */
    gotoSmall(val) {
      // console.log(val)
      // let val2  = "js:jumpQR";
      let arr = val.split(":");
      if (arr[0] === "js") {
        this.$tool.callModule(arr[1]);
      } else {
        if (val === "" || val === null) {
          this.$toast("敬请期待哟！");
        } else {
          window.location.href = `${window.location.origin}/${val}`;
          // this.$tool.sessionData('#1e3cd2', 'true');
        }
      }
    },
  },
  components: {
    Headerd,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Field.name]: Field,
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f3f3f3;
  .tips {
    margin: 0px 4px;
    padding-bottom: 1px;
    .tips_out {
      margin: 3px 12px 14px 12px;
      background: #fff;
      border-radius: 4px;
      .tips_one {
        padding: 12px 12px;
        font-size: 15px;
        font-weight: bold;
        //color: #949494;
      }
      .tips_tow {
        // margin-left: 24px;
        // margin-right: 10px;
        padding: 5px 12px;
        font-size: 14px;
        font-weight: bold;
        //color:#949494;
      }
      .tips_last {
        // margin-left: 24px;
        // margin-right: 10px;
        padding: 0px 12px;
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        text-indent: 25px;
        //color:#949494;
        padding-bottom: 10px;
        line-height: 25px;
      }
    }
  }
  .indexmain {
    overflow: hidden;

    .banner {
      width: 100%;
      height: 175px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .moreApp {
      //    background: #fff;
      display: flex;
      margin: 14px 12px 0 12px;
      flex-wrap: wrap;
      padding-bottom: 4px;
      width: 351px;
      .moreIcon {
        width: 109px;
        // height: 94px;
        text-align: center;
        background-color: #fff;
        margin: 4px auto;
        .icon {
          margin: 20px auto 0 auto;
          width: 24px;
          height: 24px;
          text-align: center;
          .appIconImg {
            width: 24px;
            padding-top: 6px;
          }
          .newImg {
            position: absolute;
            width: 14px;
            padding-left: 5px;
          }
        }
        p {
          margin: 17px auto;
          text-align: center;
          font-size: 12px;
          color: #030f26;
        }
      }
    }
  }
}
</style>

